import React from "react";
import { Box, LinearProgress } from "@material-ui/core";

export const Loading = (props: any) => (
    <Box pt={1} pb={1}>
        <LinearProgress {...props}/>
    </Box>
)
